import { formatDateTime } from '../lib/format'

/**
 * Consistent "Last updated" footer for the Settings tabs. Renders nothing
 * when there's no timestamp yet, so a never-saved config shows nothing rather
 * than a bare "Last updated —".
 */
export function SettingsUpdatedAt({ at }) {
  if (!at) return null
  return (
    <p className="mt-6 text-xs text-[color:var(--color-ink-subtle)]">
      Last updated {formatDateTime(at)}.
    </p>
  )
}
